<template>
    <div class="zhengti">
        <div  class="about">
            <div class="titlt">订好舱</div>
            <div class="jianjie">订好舱，隶属于订好舱物流科技（青岛）有限公司，是中国数字化国际物流服务平台，依托互联网技术与供应链创新，致力于为全球贸易企业提供高效、透明、低成本的一站式货运解决方案。平台以“让物流更简单”为核心使命，通过智能化工具重构传统货代行业生态，打破信息壁垒，推动国际物流产业向数字化、标准化方向升级。</div>
            <div class="fktit">网站简介</div>
            <div class="fkcon">订好舱成立于2024年，总部位于中国青岛，核心团队由资深物流专家、互联网技术人才及跨境贸易从业者组成。</div>
            <div class="fktit">网站背景</div>
            <div class="fkcon">订好舱源于传统国际货运行业的长期痛点：价格不透明、流程繁琐、服务标准缺失、中小货代同行议价能力弱等。通过整合全球航运资源与数字化技术，订好舱构建了覆盖海运在线服务体系，用户可通过PC端或移动端实现运价查询、舱位预订、订单管理、轨迹追踪等全流程操作。</div>
            <div class="fktit">网站定位</div>
            <div class="fkcon">
                订好舱首创“双系统驱动模式”，同时面向货主与物流服务商开放功能：
                <br>
                <b>货主端：</b>免费查运价、一键订舱、全程可视化追踪；
                <br>
                <b>供应商端：</b>免费发布运价、精准触达客户、智能管理订单。
                <br>
                这一模式彻底打破了传统货代行业中“信息孤岛”与“层层转包”的弊端，让供需双方直接对接，显著降低沟通成本与交易风险。
            </div>
            <div class="fktit">核心功能与服务体系</div>
            <div class="fkcon">
                <ol>
                    <li>
                        <div class="litit">智能运价查询系统：全航线透明，美加专线深度覆盖</div>
                        <b>免费查运价：</b>用户可实时获取全球主要港口（含美线、加线）的即期运价，系统支持按航线、船期、舱位类型智能筛选，并通过AI算法推荐最优方案。
                        <br>
                        <b>美加到门专查：</b>针对北美市场，平台提供“港口到门”全链路报价功能，涵盖洛杉矶、温哥华、多伦多等核心枢纽，运费明细一键拆解（含海运费、港杂费、内陆运输费等），杜绝隐性收费。
                        <br>
                        <b>动态比价引擎：</b>整合50+主流船公司及物流服务商数据，用户可横向对比价格与服务，决策效率提升90%。
                    </li>
                    <li>
                        <div class="litit">双系统供需对接：免费发布与精准获客</div>
                        供应商免费发布运价：物流企业可零成本入驻平台，发布舱位、航线、服务优势等信息，平台通过LBS定位与智能标签匹配，将信息精准推送至目标客户。
                        信用评价体系：基于交易数据构建双向评分机制，保障合作安全性。
                    </li>
                    <li>
                        <div class="litit">一键订舱与电子合同</div>
                        用户可在线完成舱位预订、合同签署及支付全流程，订舱效率较传统模式提升50%。
                    </li>
                    <li>
                        <div class="litit">全链路可视化追踪</div>
                        依托物联网与区块链技术，订好舱提供“门到门”物流轨迹追踪服务，用户可实时查看货物位置、清关状态及异常预警。平台与全球主要港口、海关系统数据互通，关键节点信息自动推送，延迟率低于行业平均水平30%。
                    </li>
                </ol>
            </div>
            <div class="fktit">行业价值</div>
            <div class="fkcon">
                <ol>
                    <li>
                        <div class="litit">赋能中小微企业</div>
                        传统货代市场中，中小货主因货量有限难以获得优质报价。订好舱通过聚合需求形成“虚拟集团采购”，帮助中小用户享受大客户协议价，降低物流成本15%-30%。
                    </li>
                    <li>
                        <div class="litit">推动行业标准化</div>
                        平台制定《在线货代服务标准》，明确舱位确认时效、赔偿条款等关键指标，倒逼传统企业提升服务质量。
                    </li>
                    <li>
                        <div class="litit">绿色物流实践</div>
                        通过优化航线规划减少燃油消耗，并推出“碳足迹计算器”，帮助用户量化运输排放，支持碳中和海运服务。
                    </li>
                </ol>
            </div>
            <div class="fktit">网站规划</div>
            <div class="fkcon">订好舱正加速拓展全球网络，计划未来三年覆盖80%以上“一带一路”沿线国家，并深化与跨境电商、制造业龙头的合作，打造“物流+供应链金融+贸易服务”的生态闭环。平台将持续投入技术研发，探索无人船、氢能源船舶等前沿领域，助力全球贸易低碳转型。
    订好舱的崛起标志着中国国际物流行业进入数字化新阶段。通过重构人、货、场的关系，平台不仅为企业降本增效，更推动着整个产业链向更高效、更绿色的方向进化，成为“中国智造”走向全球的数字基建。</div>
            
        </div>
    </div>
</template>
    
<script>
export default {
    components:{
        
    },
    data() {
        return {
        
        }
    },
    methods: {
        
    }
}
</script>
    
<style style lang="scss" scoped>
    .zhengti{
        width: 100%;
        height: 100%;
        background: #fff;
    }
    .about{
        width: 1200px;
        display: flex;
        flex-direction: column;
        margin: 0 auto;
        line-height: 24px;
        padding-bottom: 32px;
    }

    .titlt{
        font-size: 38px;
        text-align: center;
        font-weight: bold;
        margin-top: 36px;
        margin-bottom: 32px;
    }

    .jianjie{
        font-size: 22px;
        margin-bottom: 24px;
        line-height: 30px;
    }

    .fktit{
        margin-bottom: 8px;
        font-size: 20px;
        font-weight: 600;
    }

    .fkcon{
        margin-bottom: 24px;
    }

    li{
        margin-bottom: 8px;
    }
    .litit{
        margin-bottom: 4px;
        font-weight: 600;
    }
</style>